import React, { Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../authContext';
import { AnalyticsProvider } from '../../services/AnalyticsContext';
import { PlanProvider } from '../../services/PlanContext';
import Sidebar3 from './Sidebar3';
import AnimatedOutlet from '../common/AnimatedOutlet';
import { RouteErrorBoundary } from '../common/ErrorBoundary';
import { getSectionKey } from '../common/sectionKey';
import SessionGuard from './SessionGuard';
import GodModeRouteGuard from './GodModeRouteGuard';
import ManagerLayout from './ManagerLayout';

const VerifiedLayout = () => {
  const { authData } = useAuth();
  const location = useLocation();
  if (authData.user.accessRole === 'manager') {
    if (!['/manager/results', '/settings/account', '/help'].includes(location.pathname.replace(/\/+$/, ''))) return <Navigate to="/manager/results" replace />;
    return <ManagerLayout><Suspense fallback={<div role="status">Chargement…</div>}><RouteErrorBoundary><AnimatedOutlet transitionKey={location.pathname} /></RouteErrorBoundary></Suspense></ManagerLayout>;
  }
  if (location.pathname.replace(/\/+$/, '') === '/manager/results') return <Navigate to="/dashboard" replace />;

  return (
    <GodModeRouteGuard>
    <AnalyticsProvider>
      <PlanProvider>
        <Sidebar3>
          {/* Le shell reste monte. Le fallback sert au chargement initial ;
              les navigations startTransition conservent la page deja revelee
              jusqu'a ce que le prochain chunk soit disponible. */}
          <Suspense
            fallback={
              <div className="py-24 flex justify-center">
                <span className="loading loading-spinner loading-lg text-bsrate" />
              </div>
            }
          >
            {/* Une page qui leve ne doit pas emporter la barre laterale :
                l'utilisateur doit pouvoir aller ailleurs sans recharger. */}
            <RouteErrorBoundary>
              <AnimatedOutlet transitionKey={getSectionKey(location.pathname)} />
            </RouteErrorBoundary>
          </Suspense>
        </Sidebar3>
      </PlanProvider>
    </AnalyticsProvider>
    </GodModeRouteGuard>
  );
};

const ProtectedLayout = () => <SessionGuard><VerifiedLayout /></SessionGuard>;

export default ProtectedLayout;
